/** 読者向け分類は主題を基準に、この16カテゴリから1件だけ選ぶ。 */
export const THREAD_CATEGORY_NAMES = [
  "創作・作品投稿",
  "ゲーム",
  "アニメ・漫画",
  "映画・ドラマ",
  "音楽",
  "配信・動画",
  "技術・ガジェット",
  "食べ物",
  "動物",
  "スポーツ",
  "旅行・風景",
  "生活・趣味",
  "ネタ",
  "雑談",
  "その他",
  "謎",
] as const

export type ThreadCategory = (typeof THREAD_CATEGORY_NAMES)[number]

export const THREAD_CATEGORY_DEFINITIONS: Record<ThreadCategory, string> = {
  "創作・作品投稿": "自作・生成作品の披露、制作過程、感想募集が中心。既存作品の会話は作品分野へ分類する。",
  ゲーム: "ゲーム作品、攻略、プレイ体験、ゲーム業界。ゲーム機・周辺機器の製品相談は技術・ガジェット。",
  "アニメ・漫画": "アニメ、漫画、その登場人物。自作作品の披露が中心なら創作・作品投稿。",
  "映画・ドラマ": "映画、ドラマ、俳優、映像作品の感想。",
  音楽: "楽曲、演奏、歌手、音楽活動。",
  "配信・動画": "配信者、動画投稿者、配信番組が中心。ゲーム攻略などが中心ならその分野。",
  "技術・ガジェット":
    "プログラミング、AI、科学、技術的な制作手法。スマートフォン・PC・周辺機器の紹介、レビュー、購入相談、使い方。",
  食べ物: "食事、料理、飲料、飲食店。",
  動物: "ペット、野生動物、飼育。架空のキャラクターは作品分野。",
  スポーツ: "競技、選手、観戦、トレーニング。",
  "旅行・風景": "旅行、観光、場所、景色の紹介・鑑賞。",
  "生活・趣味": "日常生活、仕事、健康、人間関係、他カテゴリに該当しない趣味。",
  ネタ: "冗談、パロディ、ミームなど、笑いや遊び自体が主目的。",
  雑談: "特定の主題を定めない交流・近況のやり取り。主題不明とは区別する。",
  その他: "主題は特定できるが、他のカテゴリのどれにも該当しない。",
  謎: "本文・添付画像・参照可能なレスから主題を特定できない。未処理や呼び出し失敗とは区別する。",
}

/** OPを除き、今回のアクティブ検閲で実際に読んだ公開レスの最低件数。 */
export const MIN_AI_SUMMARY_REPLIES = 10

/** 読者向け要約は短い日本語の2〜3文に収める。 */
export const AI_SUMMARY_MAX_LENGTH = 400

/** 検索用タイトルの公開上限。 */
export const AI_SEO_TITLE_MAX_LENGTH = 60

export function isThreadCategory(value: string): value is ThreadCategory {
  return (THREAD_CATEGORY_NAMES as readonly string[]).includes(value)
}
